(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enter-gate"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var gate = document.querySelector('[data-enter-gate]');
    if (!gate) return;

    var SLEUTEL = 'enter-gate:entered';
    var onthoud = gate.getAttribute('data-remember') === 'true';
    function alBinnen() {
      if (!onthoud) return false;
      try { return sessionStorage.getItem(SLEUTEL) === '1'; } catch (e) { return false; }
    }
    function noteer() {
      if (onthoud) try { sessionStorage.setItem(SLEUTEL, '1'); } catch (e) {}
    }

    var inEditor = !!(window.Shopify && window.Shopify.designMode);
    if (alBinnen() && !inEditor) return;

    var body = document.body;
    var scrollWasOp = body.style.overflow;
    var filmEl = gate.querySelector('[data-enter-gate-film]');
    if (filmEl) {
      // Staand scherm: staande film, poster, verhouding en focus. De verhouding gaat op
      // de scène zelf, want die draagt hem inline (zie lessenboek 2026-09-03).
      var staand = window.matchMedia('(max-aspect-ratio: 3/4)').matches && filmEl.getAttribute('data-film-staand');
      if (staand) {
        var ps = filmEl.getAttribute('data-poster-staand');
        if (ps) filmEl.poster = ps;
        var rs = filmEl.getAttribute('data-ratio-staand');
        gate.style.setProperty('--enter-gate-ratio', rs);
        var sceneEl = gate.querySelector('.enter-gate__scene');
        if (sceneEl) sceneEl.style.setProperty('--enter-gate-ratio', rs);
        gate.style.setProperty('--enter-gate-focus', parseFloat(filmEl.getAttribute('data-focus-staand')) / 100 || 0.4);
      }
      filmEl.src = staand ? filmEl.getAttribute('data-film-staand') : filmEl.getAttribute('data-film-liggend');
    }

    gate.removeAttribute('hidden');
    body.style.overflow = 'hidden';

    var knop = gate.querySelector('[data-enter-gate-button]');
    if (knop) {
      knop.setAttribute('data-autofocused', '');
      try { knop.focus({ preventScroll: true }); } catch (e) { knop.focus(); }
      window.addEventListener('keydown', function () { knop.removeAttribute('data-autofocused'); }, { once: true });
    }

    var bezig = false;
    function open() {
      if (bezig) return;
      bezig = true;
      noteer();
      body.style.overflow = scrollWasOp;

      var film = gate.querySelector('[data-enter-gate-film]');
      if (film) {
        film.playbackRate = 2;
        var stoppen = function () {
          if (film.duration && film.currentTime >= film.duration * 0.6) {
            film.pause();
            gate.classList.add('enter-gate--doorgang');
            film.removeEventListener('timeupdate', stoppen);
          }
        };
        film.addEventListener('timeupdate', stoppen);
        var spelen = film.play();
        if (spelen && spelen.catch) spelen.catch(function () { gate.classList.add('enter-gate--doorgang'); });
      }

      var stroken = gate.querySelectorAll('.enter-gate__strip');
      for (var i = 0; i < stroken.length; i++) {
        var afstand = getComputedStyle(stroken[i]).getPropertyValue('--strip-weg') || '0%';
        stroken[i].style.transform = 'translate3d(' + afstand.trim() + ', 0, 0)';
      }

      gate.classList.add('enter-gate--leaving');
      var weg = function () { if (gate.parentNode) gate.parentNode.removeChild(gate); };
      var laatste = { 'enter-gate-doorgang': 1, 'enter-gate-through': 1 };
      gate.addEventListener('animationend', function (e) { if (laatste[e.animationName]) weg(); });
      gate.addEventListener('transitionend', function (e) { if (e.target === gate && e.propertyName === 'opacity') weg(); });
      setTimeout(weg, film ? 4000 : 1600);
    }

    if (knop) knop.addEventListener('click', open);
    gate.addEventListener('keydown', function (e) { if (e.key === 'Escape') open(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
